import { EventEmitter, Component, Input, Output, Directive, ElementRef, Renderer2, ChangeDetectorRef, HostListener, Injectable, ɵɵdefineInjectable, ViewChild, HostBinding, ChangeDetectionStrategy, Inject, NgModule } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';
import { Subject } from 'rxjs';
import * as screenfull from 'screenfull';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NavbarComponent = /** @class */ (function () {
    function NavbarComponent(translate) {
        this.translate = translate;
        this.isCollapsed = true;
        this.toggleHideSidebar = new EventEmitter();
    }
    /**
     * @return {?}
     */
    NavbarComponent.prototype.toggleSidebar = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var appSidebar = document.getElementsByClassName('app-sidebar')[0];
        if (appSidebar.classList.contains('hide-sidebar')) {
            this.toggleHideSidebar.emit(false);
        }
        else {
            this.toggleHideSidebar.emit(true);
        }
    };
    NavbarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-navbar',
                    template: "<!-- Navbar (Header) Starts -->\r\n<nav class=\"header-navbar navbar navbar-expand-lg navbar-light bg-faded\">\r\n    <div class=\"container-fluid\">\r\n        <div class=\"navbar-header d-flex align-items-center justify-content-between\">\r\n            <button type=\"button\" class=\"navbar-toggle d-lg-none float-left\" data-toggle=\"collapse\"\r\n                (click)=\"toggleSidebar()\">\r\n                <span class=\"sr-only\">Toggle navigation</span>\r\n                <span class=\"icon-bar\"></span>\r\n                <span class=\"icon-bar\"></span>\r\n                <span class=\"icon-bar\"></span>\r\n            </button>\r\n            <img mainLogo class=\"logo-farmportal d-lg-none\" [src]=\"logoUrl\"  />\r\n            <span class=\"d-lg-none navbar-right navbar-collapse-toggle\">\r\n                <a class=\"open-navbar-container\" (click)=\"isCollapsed = !isCollapsed\"\r\n                    [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"navbarSupportedContent\">\r\n                    <i class=\"ft-more-vertical\"></i>\r\n                </a>\r\n            </span>\r\n        </div>\r\n        <div class=\"navbar-container\">\r\n            <div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\" [ngbCollapse]=\"isCollapsed\">\r\n                <ng-content></ng-content>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</nav>\r\n<!-- Navbar (Header) Ends -->\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    NavbarComponent.ctorParameters = function () { return [
        { type: TranslateService }
    ]; };
    NavbarComponent.propDecorators = {
        logoUrl: [{ type: Input }],
        toggleHideSidebar: [{ type: Output }]
    };
    return NavbarComponent;
}());
if (false) {
    /** @type {?} */
    NavbarComponent.prototype.isCollapsed;
    /** @type {?} */
    NavbarComponent.prototype.logoUrl;
    /** @type {?} */
    NavbarComponent.prototype.toggleHideSidebar;
    /** @type {?} */
    NavbarComponent.prototype.translate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SidebarDirective = /** @class */ (function () {
    function SidebarDirective(el, renderer, router, cd) {
        this.el = el;
        this.renderer = renderer;
        this.router = router;
        this.cd = cd;
        this.navlinks = [];
        this.activeLinks = [];
        this.toggleHideSidebar = new EventEmitter();
    }
    /**
     * @return {?}
     */
    SidebarDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.activeRoute = this.router.url;
        this.innerWidth = window.innerWidth;
    };
    /**
     * @return {?}
     */
    SidebarDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var element = this.el.nativeElement;
        // tslint:disable-next-line: no-commented-code
        this.$wrapper = this.renderer.parentNode(this.el.nativeElement); // document.getElementsByClassName("wrapper")[0];
        // document.getElementsByClassName("wrapper")[0];
        // tslint:disable-next-line: variable-name
        /** @type {?} */
        var sidebar_img_container = this.el.nativeElement.querySelector('.sidebar-background');
        // tslint:disable-next-line: variable-name
        /** @type {?} */
        var $sidebar_img = element.getAttribute('data-image');
        if (sidebar_img_container.length !== 0 && $sidebar_img !== undefined) {
            this.renderer.setAttribute(sidebar_img_container, 'style', 'background-image: url("' + $sidebar_img + '")');
        }
        // tslint:disable-next-line: no-duplicate-string
        if (!this.$wrapper.classList.contains('nav-collapsed')) {
            this.expandActive();
        }
        if (this.innerWidth < 992) {
            this.renderer.removeClass(this.$wrapper, 'nav-collapsed');
            // tslint:disable-next-line: no-duplicate-string
            this.renderer.removeClass(this.$wrapper, 'menu-collapsed');
            this.toggleHideSidebar.emit(true);
        }
        this.cd.detectChanges();
    };
    /**
     * @param {?} e
     * @return {?}
     */
    SidebarDirective.prototype.onMouseOver = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this.$wrapper.classList.contains('nav-collapsed')) {
            this.renderer.removeClass(this.$wrapper, 'menu-collapsed');
            this.navlinks
                .filter((/**
             * @param {?} _
             * @return {?}
             */
            function (_) { return _.navCollapsedOpen === true; }))
                .forEach((/**
             * @param {?} link
             * @return {?}
             */
            function (link) {
                link.open = true;
                link.navCollapsedOpen = false;
            }));
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    SidebarDirective.prototype.onMouseOut = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this.$wrapper.classList.contains('nav-collapsed')) {
            this.renderer.addClass(this.$wrapper, 'menu-collapsed');
            this.navlinks
                .filter((/**
             * @param {?} _
             * @return {?}
             */
            function (_) { return _.open === true; }))
                .forEach((/**
             * @param {?} link
             * @return {?}
             */
            function (link) {
                link.open = false;
                link.navCollapsedOpen = true;
            }));
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    SidebarDirective.prototype.onClick = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (e.target.parentElement.classList.contains('logo-text') ||
            e.target.parentElement.classList.contains('logo-img')) {
            this.activeLinks = [];
            this.activeRoute = this.router.url;
            this.expandActive();
            this.hideSidebar();
        }
        else if (e.target.parentElement.classList.contains('nav-close') ||
            e.target.classList.contains('nav-close')) {
            this.toggleHideSidebar.emit(true);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SidebarDirective.prototype.onResize = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.innerWidth = window.innerWidth;
        if (event.target.innerWidth < 992) {
            this.renderer.removeClass(this.$wrapper, 'nav-collapsed');
            this.renderer.removeClass(this.$wrapper, 'menu-collapsed');
            this.toggleHideSidebar.emit(true);
        }
        if (event.target.innerWidth > 992) {
            /** @type {?} */
            var toggleStatus = this.el.nativeElement;
            this.el.nativeElement.querySelector('.toggle-icon')
                .getAttribute('data-toggle');
            if (toggleStatus === 'collapsed' &&
                this.$wrapper.classList.contains('nav-collapsed') &&
                this.$wrapper.classList.contains('menu-collapsed')) {
                this.$wrapper.classList.add('nav-collapsed');
                this.$wrapper.classList.add('menu-collapsed');
            }
            this.toggleHideSidebar.emit(false);
        }
    };
    // check outside click and close sidebar for smaller screen <992
    // check outside click and close sidebar for smaller screen <992
    /**
     * @param {?} event
     * @return {?}
     */
    SidebarDirective.prototype.onOutsideClick = 
    // check outside click and close sidebar for smaller screen <992
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.innerWidth < 992) {
            /** @type {?} */
            var clickedComponent = event.target;
            /** @type {?} */
            var inside = false;
            do {
                if (clickedComponent === this.el.nativeElement) {
                    inside = true;
                }
                clickedComponent = clickedComponent.parentNode;
            } while (clickedComponent);
            if (!this.el.nativeElement.classList.contains('hide-sidebar') &&
                !inside &&
                !event.target.classList.contains('navbar-toggle')) {
                this.toggleHideSidebar.emit(true);
            }
        }
    };
    /**
     * @param {?} link
     * @return {?}
     */
    SidebarDirective.prototype.addLink = /**
     * @param {?} link
     * @return {?}
     */
    function (link) {
        this.navlinks.push(link);
    };
    /**
     * @return {?}
     */
    SidebarDirective.prototype.getLinks = /**
     * @return {?}
     */
    function () {
        return this.navlinks;
    };
    /**
     * @return {?}
     */
    SidebarDirective.prototype.hideSidebar = /**
     * @return {?}
     */
    function () {
        if (this.innerWidth < 992) {
            this.toggleHideSidebar.emit(true);
        }
    };
    /**
     * @return {?}
     */
    SidebarDirective.prototype.expandActive = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.navlinks
            .filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _.routePath === _this.activeRoute; }))
            .forEach((/**
         * @param {?} link
         * @return {?}
         */
        function (link) {
            link.isShown = true;
            if (link.level.toString().trim() === '3') {
                _this.navlinks
                    .filter((/**
                 * @param {?} _
                 * @return {?}
                 */
                function (_) { return _.level.toString().trim() === '2' && _.title === link.parent; }))
                    .forEach((/**
                 * @param {?} parentLink
                 * @return {?}
                 */
                function (parentLink) {
                    parentLink.open = true;
                    _this.activeLinks.push(parentLink.title);
                    _this.navlinks
                        .filter((/**
                     * @param {?} _
                     * @return {?}
                     */
                    function (_) {
                        return _.level.toString().trim() === '1' &&
                            _.title === parentLink.parent;
                    }))
                        .forEach((/**
                     * @param {?} superParentLink
                     * @return {?}
                     */
                    function (superParentLink) {
                        superParentLink.open = true;
                        _this.activeLinks.push(superParentLink.title);
                        superParentLink.toggleEmit.emit(_this.activeLinks);
                    }));
                }));
            }
            else if (link.level.toString().trim() === '2') {
                _this.navlinks
                    .filter((/**
                 * @param {?} _
                 * @return {?}
                 */
                function (_) { return _.level.toString().trim() === '1' && _.title === link.parent; }))
                    .forEach((/**
                 * @param {?} parentLink
                 * @return {?}
                 */
                function (parentLink) {
                    parentLink.open = true;
                    _this.activeLinks.push(parentLink.title);
                    parentLink.toggleEmit.emit(_this.activeLinks);
                }));
            }
        }));
    };
    /**
     * @return {?}
     */
    SidebarDirective.prototype.toggleActiveList = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.navlinks
            .filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            return _.level.toString().trim() === '3' && _.routePath !== _this.activeRoute;
        }))
            .forEach((/**
         * @param {?} link
         * @return {?}
         */
        function (link) {
            link.active = false;
        }));
    };
    /**
     * @param {?} parentLink
     * @return {?}
     */
    SidebarDirective.prototype.setIsShown = /**
     * @param {?} parentLink
     * @return {?}
     */
    function (parentLink) {
        /** @type {?} */
        var childLevel = Number(parentLink.level) + 1;
        this.navlinks
            .filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            return _.level.toString().trim() === childLevel.toString().trim() &&
                _.parent === parentLink.title;
        }))
            .forEach((/**
         * @param {?} link
         * @return {?}
         */
        function (link) {
            link.isShown = true;
            link.isHidden = false;
        }));
    };
    /**
     * @param {?} parentLink
     * @return {?}
     */
    SidebarDirective.prototype.setIsHidden = /**
     * @param {?} parentLink
     * @return {?}
     */
    function (parentLink) {
        /** @type {?} */
        var childLevel = Number(parentLink.level) + 1;
        this.navlinks
            .filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            return _.level.toString().trim() === childLevel.toString().trim() &&
                _.parent === parentLink.title;
        }))
            .forEach((/**
         * @param {?} link
         * @return {?}
         */
        function (link) {
            link.isShown = false;
            link.isHidden = true;
        }));
    };
    SidebarDirective.decorators = [
        { type: Directive, args: [{ selector: '[appSidebar]' },] }
    ];
    /** @nocollapse */
    SidebarDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: Router },
        { type: ChangeDetectorRef }
    ]; };
    SidebarDirective.propDecorators = {
        toggleHideSidebar: [{ type: Output }],
        onMouseOver: [{ type: HostListener, args: ['mouseenter', ['$event'],] }],
        onMouseOut: [{ type: HostListener, args: ['mouseleave', ['$event'],] }],
        onClick: [{ type: HostListener, args: ['click', ['$event'],] }],
        onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }],
        onOutsideClick: [{ type: HostListener, args: ['document:click', ['$event'],] }]
    };
    return SidebarDirective;
}());
if (false) {
    /** @type {?} */
    SidebarDirective.prototype.navlinks;
    /** @type {?} */
    SidebarDirective.prototype.activeLinks;
    /**
     * @type {?}
     * @protected
     */
    SidebarDirective.prototype.$wrapper;
    /**
     * @type {?}
     * @private
     */
    SidebarDirective.prototype.activeRoute;
    /**
     * @type {?}
     * @protected
     */
    SidebarDirective.prototype.innerWidth;
    /** @type {?} */
    SidebarDirective.prototype.toggleHideSidebar;
    /**
     * @type {?}
     * @private
     */
    SidebarDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    SidebarDirective.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    SidebarDirective.prototype.router;
    /**
     * @type {?}
     * @private
     */
    SidebarDirective.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LayoutService = /** @class */ (function () {
    function LayoutService() {
        this.emitChangeSource = new Subject();
        this.changeEmitted$ = this.emitChangeSource.asObservable();
        // Customizer
        this.emitCustomizerSource = new Subject();
        this.customizerChangeEmitted$ = this.emitCustomizerSource.asObservable();
        // customizer - compact menu
        this.emitCustomizerCMSource = new Subject();
        this.customizerCMChangeEmitted$ = this.emitCustomizerCMSource.asObservable();
        // customizer - compact menu
        this.emitNotiSidebarSource = new Subject();
        this.notiSidebarChangeEmitted$ = this.emitNotiSidebarSource.asObservable();
    }
    /**
     * @param {?} change
     * @return {?}
     */
    LayoutService.prototype.emitChange = /**
     * @param {?} change
     * @return {?}
     */
    function (change) {
        this.emitChangeSource.next(change);
    };
    /**
     * @param {?} change
     * @return {?}
     */
    LayoutService.prototype.emitCustomizerChange = /**
     * @param {?} change
     * @return {?}
     */
    function (change) {
        this.emitCustomizerSource.next(change);
    };
    /**
     * @param {?} change
     * @return {?}
     */
    LayoutService.prototype.emitCustomizerCMChange = /**
     * @param {?} change
     * @return {?}
     */
    function (change) {
        this.emitCustomizerCMSource.next(change);
    };
    /**
     * @param {?} change
     * @return {?}
     */
    LayoutService.prototype.emitNotiSidebarChange = /**
     * @param {?} change
     * @return {?}
     */
    function (change) {
        this.emitNotiSidebarSource.next(change);
    };
    LayoutService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ LayoutService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LayoutService_Factory() { return new LayoutService(); }, token: LayoutService, providedIn: "root" });
    return LayoutService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    LayoutService.prototype.emitChangeSource;
    /** @type {?} */
    LayoutService.prototype.changeEmitted$;
    /**
     * @type {?}
     * @private
     */
    LayoutService.prototype.emitCustomizerSource;
    /** @type {?} */
    LayoutService.prototype.customizerChangeEmitted$;
    /**
     * @type {?}
     * @private
     */
    LayoutService.prototype.emitCustomizerCMSource;
    /** @type {?} */
    LayoutService.prototype.customizerCMChangeEmitted$;
    /**
     * @type {?}
     * @private
     */
    LayoutService.prototype.emitNotiSidebarSource;
    /** @type {?} */
    LayoutService.prototype.notiSidebarChangeEmitted$;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NotificationSidebarComponent = /** @class */ (function () {
    function NotificationSidebarComponent(renderer, layoutService) {
        var _this = this;
        this.renderer = renderer;
        this.isOpen = false;
        this.layoutSub = layoutService.notiSidebarChangeEmitted$.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (_this.isOpen) {
                _this.renderer.removeClass(_this.sidebar.nativeElement, 'open');
                _this.isOpen = false;
            }
            else {
                _this.renderer.addClass(_this.sidebar.nativeElement, 'open');
                _this.isOpen = true;
            }
        }));
    }
    /**
     * @return {?}
     */
    NotificationSidebarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    NotificationSidebarComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.layoutSub) {
            this.layoutSub.unsubscribe();
        }
    };
    /**
     * @return {?}
     */
    NotificationSidebarComponent.prototype.onClose = /**
     * @return {?}
     */
    function () {
        this.renderer.removeClass(this.sidebar.nativeElement, 'open');
        this.isOpen = false;
    };
    NotificationSidebarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-notification-sidebar',
                    template: "<!-- //////////////////////////////////////////////////////////////////////////// -->\r\n<!-- START Notification Sidebar -->\r\n<aside #sidebar id=\"notification-sidebar\" class=\"notification-sidebar d-none d-sm-none d-md-block\">\r\n  <a class=\"notification-sidebar-close\" (click)=\"onClose()\">\r\n    <i class=\"ft-x font-medium-3\"></i>\r\n  </a>\r\n  <div class=\"side-nav notification-sidebar-content\" [perfectScrollbar]>\r\n    <div class=\"row\">\r\n      <div class=\"col-12 mt-1\">\r\n        <ngb-tabset>\r\n          <ngb-tab>\r\n            <ng-template ngbTabTitle><b>Activity</b></ng-template>\r\n            <ng-template ngbTabContent>\r\n              <div id=\"activity\" class=\"col-12 timeline-left\">\r\n                <h6 class=\"mt-1 mb-3 text-bold-400 text-left\">RECENT ACTIVITY</h6>\r\n                <div id=\"timeline\" class=\"timeline-left timeline-wrapper\">\r\n                  <ul class=\"timeline\">\r\n                    <li class=\"timeline-line\"></li>\r\n                    <li class=\"timeline-item text-left text-left\">\r\n                      <div class=\"timeline-badge\">\r\n                        <span class=\"bg-purple bg-lighten-1\" data-toggle=\"tooltip\" data-placement=\"right\"\r\n                          title=\"Portfolio project work\"><i class=\"ft-shopping-cart\"></i></span>\r\n                      </div>\r\n                      <div class=\"col s9 recent-activity-list-text\">\r\n                        <a href=\"#\" class=\"deep-purple-text medium-small\">just now</a>\r\n                        <p class=\"mt-0 mb-2 fixed-line-height font-weight-300 medium-small\">Jim Doe Purchased new\r\n                          equipments for zonal office.</p>\r\n                      </div>\r\n                    </li>\r\n                    <li class=\"timeline-item text-left\">\r\n                      <div class=\"timeline-badge\">\r\n                        <span class=\"bg-info bg-lighten-1\" data-toggle=\"tooltip\" data-placement=\"right\"\r\n                          title=\"Portfolio project work\"><i class=\"fa fa-plane\"></i></span>\r\n                      </div>\r\n                      <div class=\"col s9 recent-activity-list-text\">\r\n                        <a href=\"#\" class=\"cyan-text medium-small\">Yesterday</a>\r\n                        <p class=\"mt-0 mb-2 fixed-line-height font-weight-300 medium-small\">Your Next flight for USA\r\n                          will be on 15th August 2015.</p>\r\n                      </div>\r\n                    </li>\r\n                    <li class=\"timeline-item text-left\">\r\n                      <div class=\"timeline-badge\">\r\n                        <span class=\"bg-success bg-lighten-1\" data-toggle=\"tooltip\" data-placement=\"right\"\r\n                          title=\"Portfolio project work\"><i class=\"ft-mic\"></i></span>\r\n                      </div>\r\n                      <div class=\"col s9 recent-activity-list-text\">\r\n                        <a href=\"#\" class=\"green-text medium-small\">5 Days Ago</a>\r\n                        <p class=\"mt-0 mb-2 fixed-line-height font-weight-300 medium-small\">Natalya Parker Send you a\r\n                          voice mail for next conference.</p>\r\n                      </div>\r\n                    </li>\r\n                    <li class=\"timeline-item text-left\">\r\n                      <div class=\"timeline-badge\">\r\n                        <span class=\"bg-warning bg-lighten-1\" data-toggle=\"tooltip\" data-placement=\"right\"\r\n                          title=\"Portfolio project work\"><i class=\"ft-map-pin\"></i></span>\r\n                      </div>\r\n                      <div class=\"col s9 recent-activity-list-text\">\r\n                        <a href=\"#\" class=\"amber-text medium-small\">1 Week Ago</a>\r\n                        <p class=\"mt-0 mb-2 fixed-line-height font-weight-300 medium-small\">Jessy Jay open a new store\r\n                          at S.G Road.</p>\r\n                      </div>\r\n                    </li>\r\n                    <li class=\"timeline-item text-left\">\r\n                      <div class=\"timeline-badge\">\r\n                        <span class=\"bg-red bg-lighten-1\" data-toggle=\"tooltip\" data-placement=\"right\"\r\n                          title=\"Portfolio project work\"><i class=\"ft-inbox\"></i></span>\r\n                      </div>\r\n                      <div class=\"col s9 recent-activity-list-text\">\r\n                        <a href=\"#\" class=\"deep-orange-text medium-small\">2 Week Ago</a>\r\n                        <p class=\"mt-0 mb-2 fixed-line-height font-weight-300 medium-small\">voice mail for conference.\r\n                        </p>\r\n                      </div>\r\n                    </li>\r\n                    <li class=\"timeline-item text-left\">\r\n                      <div class=\"timeline-badge\">\r\n                        <span class=\"bg-cyan bg-lighten-1\" data-toggle=\"tooltip\" data-placement=\"right\"\r\n                          title=\"Portfolio project work\"><i class=\"ft-mic\"></i></span>\r\n                      </div>\r\n                      <div class=\"col s9 recent-activity-list-text\">\r\n                        <a href=\"#\" class=\"brown-text medium-small\">1 Month Ago</a>\r\n                        <p class=\"mt-0 mb-2 fixed-line-height font-weight-300 medium-small\">Natalya Parker Send you a\r\n                          voice mail for next conference.</p>\r\n                      </div>\r\n                    </li>\r\n                    <li class=\"timeline-item text-left\">\r\n                      <div class=\"timeline-badge\">\r\n                        <span class=\"bg-amber bg-lighten-1\" data-toggle=\"tooltip\" data-placement=\"right\"\r\n                          title=\"Portfolio project work\"><i class=\"ft-map-pin\"></i></span>\r\n                      </div>\r\n                      <div class=\"col s9 recent-activity-list-text\">\r\n                        <a href=\"#\" class=\"deep-purple-text medium-small\">3 Month Ago</a>\r\n                        <p class=\"mt-0 mb-2 fixed-line-height font-weight-300 medium-small\">Jessy Jay open a new store\r\n                          at S.G Road.</p>\r\n                      </div>\r\n                    </li>\r\n                    <li class=\"timeline-item text-left\">\r\n                      <div class=\"timeline-badge\">\r\n                        <span class=\"bg-grey bg-lighten-1\" data-toggle=\"tooltip\" data-placement=\"right\"\r\n                          title=\"Portfolio project work\"><i class=\"ft-inbox\"></i></span>\r\n                      </div>\r\n                      <div class=\"col s9 recent-activity-list-text\">\r\n                        <a href=\"#\" class=\"grey-text medium-small\">1 Year Ago</a>\r\n                        <p class=\"mt-0 mb-2 fixed-line-height font-weight-300 medium-small\">voice mail for conference.\r\n                        </p>\r\n                      </div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n              </div>\r\n            </ng-template>\r\n          </ngb-tab>\r\n          <ngb-tab>\r\n            <ng-template ngbTabTitle><b>Chat</b></ng-template>\r\n            <ng-template ngbTabContent>\r\n              <div id=\"chatapp\" class=\"col-12\">\r\n                <h6 class=\"mt-1 mb-3 text-bold-400 text-left\">RECENT CHAT</h6>\r\n                <div class=\"collection border-none\">\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-12.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">Elizabeth Elliott </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">5.00 AM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Thank you </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-6.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">Mary Adams </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">4.14 AM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Hello Boo </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-11.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">Caleb Richards </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">9.00 PM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Keny ! </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-18.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">June Lane </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">4.14 AM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Ohh God </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-1.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">Edward Fletcher </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">5.15 PM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Love you </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-2.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">Crystal Bates </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">8.00 AM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Can we </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-3.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">Nathan Watts </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">9.53 PM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Great! </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-15.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">Willard Wood </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">4.20 AM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Do it </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-19.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">Ronnie Ellis </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">5.30 PM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Got that </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-14.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">Gwendolyn Wood </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">4.34 AM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Like you </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-13.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">Daniel Russell </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">12.00 AM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Thank you </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-22.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">Sarah Graves </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">11.14 PM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Okay you </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-9.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">Andrew Hoffman </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">7.30 PM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Can do </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media mb-1\">\r\n                    <a>\r\n                      <img alt=\"96x96\" class=\"media-object d-flex mr-3 bg-primary height-50 rounded-circle\"\r\n                        src=\"assets/img/portrait/small/avatar-s-20.png\">\r\n                    </a>\r\n                    <div class=\"media-body text-left\">\r\n                      <div class=\"clearfix\">\r\n                        <h4 class=\"font-medium-1 primary mt-1 mb-0 mr-auto float-left\">Camila Lynch </h4>\r\n                        <span class=\"medium-small float-right blue-grey-text text-lighten-3\">2.00 PM</span>\r\n                      </div>\r\n                      <p class=\"text-muted font-small-3\">Leave it </p>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </ng-template>\r\n          </ngb-tab>\r\n          <ngb-tab>\r\n            <ng-template ngbTabTitle><b>Settings</b></ng-template>\r\n            <ng-template ngbTabContent>\r\n              <div id=\"settings\" class=\"col-12\">\r\n                <h6 class=\"mt-1 mb-3 text-bold-400 text-left\">GENERAL SETTINGS</h6>\r\n                <ul class=\"list-unstyled\">\r\n                  <li class=\"text-left\">\r\n                    <div class=\"togglebutton\">\r\n                      <div class=\"switch d-flex justify-content-between w-100\">\r\n                        <span class=\"text-bold-500\">Notifications</span>\r\n                        <div class=\"notification-cb\">\r\n                          <div class=\"custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0\">\r\n                            <input checked=\"checked\" class=\"custom-control-input \" type=\"checkbox\"\r\n                              id=\"notifications1\">\r\n                            <label class=\"custom-control-label d-block\" for=\"notifications1\"></label>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <p>Use checkboxes when looking for yes or no answers.</p>\r\n                  </li>\r\n                  <li class=\"text-left\">\r\n                    <div class=\"togglebutton\">\r\n                      <div class=\"switch d-flex justify-content-between w-100\">\r\n                        <span class=\"text-bold-500\">Show recent activity</span>\r\n                        <div class=\"notification-cb\">\r\n                          <div class=\"custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0\">\r\n                            <input checked=\"checked\" class=\"custom-control-input \" type=\"checkbox\"\r\n                              id=\"recent-activity1\">\r\n                            <label class=\"custom-control-label d-block\" for=\"recent-activity1\"></label>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <p>The for attribute is necessary to bind our custom checkbox with the input.</p>\r\n                  </li>\r\n                  <li class=\"text-left\">\r\n                    <div class=\"togglebutton\">\r\n                      <div class=\"switch  d-flex justify-content-between w-100\">\r\n                        <span class=\"text-bold-500\">Notifications</span>\r\n                        <div class=\"notification-cb\">\r\n                          <div class=\"custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0\">\r\n                            <input class=\"custom-control-input \" type=\"checkbox\" id=\"notifications2\">\r\n                            <label class=\"custom-control-label d-block\" for=\"notifications2\"></label>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <p>Use checkboxes when looking for yes or no answers.</p>\r\n                  </li>\r\n                  <li class=\"text-left\">\r\n                    <div class=\"togglebutton\">\r\n                      <div class=\"switch d-flex justify-content-between w-100\">\r\n                        <span class=\"text-bold-500\">Show recent activity</span>\r\n                        <div class=\"notification-cb\">\r\n                          <div class=\"custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0\">\r\n                            <input class=\"custom-control-input \" type=\"checkbox\"\r\n                              id=\"recent-activity2\">\r\n                            <label class=\"custom-control-label d-block\" for=\"recent-activity2\"></label>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <p>The for attribute is necessary to bind our custom checkbox with the input.</p>\r\n                  </li>\r\n                  <li class=\"text-left\">\r\n                    <div class=\"togglebutton\">\r\n                      <div class=\"switch d-flex justify-content-between w-100\">\r\n                        <span class=\"text-bold-500\">Show your emails</span>\r\n                        <div class=\"notification-cb\">\r\n                          <div class=\"custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0\">\r\n                            <input class=\"custom-control-input \" type=\"checkbox\" id=\"show-emails\">\r\n                            <label class=\"custom-control-label d-block\" for=\"show-emails\"></label>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <p>Use checkboxes when looking for yes or no answers.</p>\r\n                  </li>\r\n                  <li class=\"text-left\">\r\n                    <div class=\"togglebutton\">\r\n                      <div class=\"switch d-flex justify-content-between w-100\">\r\n                        <span class=\"text-bold-500\">Show Task statistics</span>\r\n                        <div class=\"notification-cb\">\r\n                          <div class=\"custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0\">\r\n                            <input class=\"custom-control-input \" type=\"checkbox\" id=\"show-stats\">\r\n                            <label class=\"custom-control-label d-block\" for=\"show-stats\"></label>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <p>The for attribute is necessary to bind our custom checkbox with the input.</p>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n            </ng-template>\r\n          </ngb-tab>\r\n        </ngb-tabset>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</aside>\r\n<!-- END Notification Sidebar -->",
                    styles: ["#notification-sidebar{width:400px;right:-400px;padding:0;background-color:#fff;z-index:1051;position:fixed;top:0;bottom:0;height:100vh;transition:right .4s cubic-bezier(.05,.74,.2,.99);-webkit-backface-visibility:hidden;backface-visibility:hidden;border-left:1px solid rgba(0,0,0,.05);box-shadow:0 0 8px rgba(0,0,0,.1)}#notification-sidebar.open{right:0}#notification-sidebar .notification-sidebar-content{position:relative;height:100%;padding:10px}#notification-sidebar .notification-sidebar-content #settings .switch,#notification-sidebar .notification-sidebar-content #timeline.timeline-left .timeline-item:after,#notification-sidebar .notification-sidebar-content #timeline.timeline-left .timeline-item:before{border:none}#notification-sidebar a.notification-sidebar-toggle{background:#fff;color:theme-color(\"primary\");display:block;box-shadow:-3px 0 8px rgba(0,0,0,.1)}#notification-sidebar a.notification-sidebar-close{color:#000}#notification-sidebar .notification-sidebar-close{position:absolute;right:10px;top:10px;padding:7px;width:auto;z-index:10}#notification-sidebar .notification-sidebar-toggle{position:absolute;top:35%;width:54px;height:50px;left:-54px;text-align:center;line-height:50px;cursor:pointer}[dir=rtl] :host ::ng-deep #notification-sidebar{left:-400px;right:auto}[dir=rtl] :host ::ng-deep #notification-sidebar.open{left:0;right:auto}[dir=rtl] :host ::ng-deep #notification-sidebar .notification-sidebar-close{left:10px;right:auto}[dir=rtl] :host ::ng-deep #notification-sidebar .notification-sidebar-toggle{right:-54px;left:auto}"]
                }] }
    ];
    /** @nocollapse */
    NotificationSidebarComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: LayoutService }
    ]; };
    NotificationSidebarComponent.propDecorators = {
        sidebar: [{ type: ViewChild, args: ['sidebar', { static: false },] }]
    };
    return NotificationSidebarComponent;
}());
if (false) {
    /** @type {?} */
    NotificationSidebarComponent.prototype.layoutSub;
    /** @type {?} */
    NotificationSidebarComponent.prototype.isOpen;
    /** @type {?} */
    NotificationSidebarComponent.prototype.sidebar;
    /**
     * @type {?}
     * @private
     */
    NotificationSidebarComponent.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FullscreenService = /** @class */ (function () {
    function FullscreenService() {
        var _this = this;
        this.fullscreenLib = screenfull;
        this.fullscreenLib.onchange((/**
         * @return {?}
         */
        function () { return _this._isFullscreen = _this.fullscreenLib.isFullscreen; }));
    }
    Object.defineProperty(FullscreenService.prototype, "isFullscreen", {
        get: /**
         * @return {?}
         */
        function () {
            return this._isFullscreen;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FullscreenService.prototype.toggle = /**
     * @return {?}
     */
    function () {
        if (this.fullscreenLib.enabled) {
            this.fullscreenLib.toggle();
        }
    };
    FullscreenService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    FullscreenService.ctorParameters = function () { return []; };
    /** @nocollapse */ FullscreenService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FullscreenService_Factory() { return new FullscreenService(); }, token: FullscreenService, providedIn: "root" });
    return FullscreenService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    FullscreenService.prototype.fullscreenLib;
    /**
     * @type {?}
     * @private
     */
    FullscreenService.prototype._isFullscreen;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ToggleFullscreenDirective = /** @class */ (function () {
    function ToggleFullscreenDirective(fullscreenService) {
        this.fullscreenService = fullscreenService;
    }
    Object.defineProperty(ToggleFullscreenDirective.prototype, "className", {
        get: /**
         * @return {?}
         */
        function () {
            return this.fullscreenService.isFullscreen;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ToggleFullscreenDirective.prototype.onClick = /**
     * @return {?}
     */
    function () {
        this.fullscreenService.toggle();
    };
    ToggleFullscreenDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[apexToggleFullscreen]'
                },] }
    ];
    /** @nocollapse */
    ToggleFullscreenDirective.ctorParameters = function () { return [
        { type: FullscreenService }
    ]; };
    ToggleFullscreenDirective.propDecorators = {
        className: [{ type: HostBinding, args: ['class.fullscreen',] }],
        onClick: [{ type: HostListener, args: ['click',] }]
    };
    return ToggleFullscreenDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ToggleFullscreenDirective.prototype.fullscreenService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConfigService = /** @class */ (function () {
    function ConfigService() {
        this.setConfigValue();
    }
    /**
     * @return {?}
     */
    ConfigService.prototype.setConfigValue = /**
     * @return {?}
     */
    function () {
        this.templateConf = {
            layout: {
                variant: 'Light',
                // options:  Dark, Light & Transparent
                dir: 'ltr',
                // Options: ltr, rtl
                customizer: {
                    hidden: false // options: true, false
                },
                sidebar: {
                    collapsed: false,
                    // options: true, false
                    size: 'sidebar-md',
                    // Options: 'sidebar-lg', 'sidebar-md', 'sidebar-sm'
                    // tslint:disable-next-line: max-line-length
                    backgroundColor: 'man-of-steel',
                    // Options: 'black', 'pomegranate', 'king-yna', 'ibiza-sunset', 'flickr', 'purple-bliss', 'man-of-steel', 'purple-love'
                    /* If you want transparent layout add any of the following mentioned classes to backgroundColor of sidebar option :
                                bg-glass-1, bg-glass-2, bg-glass-3, bg-glass-4, bg-hibiscus,
                                bg-purple-pizzaz, bg-blue-lagoon, bg-electric-viloet, bg-protage, bg-tundora
                              */
                    backgroundImage: true,
                    // Options: true, false | Set true to show background image
                    backgroundImageURL: 'assets/img/sidebar-bg/01.jpg'
                }
            }
        };
    };
    ConfigService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ConfigService.ctorParameters = function () { return []; };
    /** @nocollapse */ ConfigService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ConfigService_Factory() { return new ConfigService(); }, token: ConfigService, providedIn: "root" });
    return ConfigService;
}());
if (false) {
    /** @type {?} */
    ConfigService.prototype.templateConf;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var customAnimations = [
    trigger('slideInOut', [
        state('1', style({ height: '*' })),
        state('0', style({ height: '0px' })),
        transition('1 <=> 0', animate(200))
    ])
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SidebarComponent = /** @class */ (function () {
    function SidebarComponent(renderer, router, translate, configService, layoutService) {
        var _this = this;
        this.renderer = renderer;
        this.router = router;
        this.translate = translate;
        this.configService = configService;
        this.activeTitles = [];
        // tslint:disable-next-line: variable-name
        this.nav_collapsed_open = false;
        this.config = {};
        if (this.depth === undefined) {
            this.depth = 0;
            this.expanded = true;
        }
        this.layoutSub = layoutService.customizerChangeEmitted$.subscribe((/**
         * @param {?} options
         * @return {?}
         */
        function (options) {
            if (options) {
                if (options.compactMenu === true) {
                    _this.expanded = false;
                    // tslint:disable-next-line: no-duplicate-string
                    _this.renderer.addClass(_this.toggleIcon.nativeElement, 'ft-toggle-left');
                    // tslint:disable-next-line: no-duplicate-string
                    _this.renderer.removeClass(_this.toggleIcon.nativeElement, 'ft-toggle-right');
                    _this.nav_collapsed_open = true;
                }
                else if (options.compactMenu === false) {
                    _this.expanded = true;
                    _this.renderer.removeClass(_this.toggleIcon.nativeElement, 'ft-toggle-left');
                    _this.renderer.addClass(_this.toggleIcon.nativeElement, 'ft-toggle-right');
                    _this.nav_collapsed_open = false;
                }
            }
        }));
    }
    /**
     * @return {?}
     */
    SidebarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.config = this.configService.templateConf;
    };
    /**
     * @return {?}
     */
    SidebarComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            // tslint:disable-next-line: triple-equals
            if (_this.config.layout.sidebar.collapsed != undefined) {
                if (_this.config.layout.sidebar.collapsed === true) {
                    _this.expanded = false;
                    _this.renderer.addClass(_this.toggleIcon.nativeElement, 'ft-toggle-left');
                    _this.renderer.removeClass(_this.toggleIcon.nativeElement, 'ft-toggle-right');
                    _this.nav_collapsed_open = true;
                }
                else if (_this.config.layout.sidebar.collapsed === false) {
                    _this.expanded = true;
                    _this.renderer.removeClass(_this.toggleIcon.nativeElement, 'ft-toggle-left');
                    _this.renderer.addClass(_this.toggleIcon.nativeElement, 'ft-toggle-right');
                    _this.nav_collapsed_open = false;
                }
            }
        }), 0);
    };
    /**
     * @return {?}
     */
    SidebarComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.layoutSub) {
            this.layoutSub.unsubscribe();
        }
    };
    /**
     * @return {?}
     */
    SidebarComponent.prototype.toggleSlideInOut = /**
     * @return {?}
     */
    function () {
        this.expanded = !this.expanded;
    };
    /**
     * @param {?} titles
     * @return {?}
     */
    SidebarComponent.prototype.handleToggle = /**
     * @param {?} titles
     * @return {?}
     */
    function (titles) {
        this.activeTitles = titles;
    };
    // NGX Wizard - skip url change
    // NGX Wizard - skip url change
    /**
     * @param {?} path
     * @return {?}
     */
    SidebarComponent.prototype.ngxWizardFunction = 
    // NGX Wizard - skip url change
    /**
     * @param {?} path
     * @return {?}
     */
    function (path) {
        if (path.indexOf('forms/ngx') !== -1) {
            this.router.navigate(['forms/ngx/wizard'], { skipLocationChange: false });
        }
    };
    SidebarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-sidebar',
                    template: "<!-- Sidebar Header starts -->\r\n<div class=\"sidebar\">\r\n    <div class=\"sidebar-header\">\r\n        <div class=\"logo clearfix\">\r\n            <a class=\"nav-toggle d-none d-sm-none d-md-none d-lg-block\" id=\"sidebarToggle\" href=\"javascript:;\">\r\n                <i #toggleIcon appSidebarToggle class=\"ft-toggle-right toggle-icon\" data-toggle=\"expanded\"></i>\r\n            </a>\r\n            <a class=\"nav-close d-block d-md-block d-lg-none d-xl-none\" id=\"sidebarClose\" href=\"javascript:;\">\r\n                <i class=\"ft-x\"></i>\r\n            </a>\r\n        </div>\r\n    </div>\r\n    <!-- Sidebar Header Ends -->\r\n    <!-- Sidebar Content starts -->\r\n    <div class=\"sidebar-content\" [perfectScrollbar]>\r\n        <div class=\"nav-container\">\r\n            <ul class=\"navigation\" appSidebarList>\r\n                <!-- First level menu -->\r\n                <li appSidebarlink level=\"{{depth + 1}}\" (toggleEmit)=\"handleToggle($event)\" (click)=\"toggleSlideInOut()\"\r\n                    [routePath]=\"menuItem.path\" [classes]=\"menuItem.class\" [title]=\"menuItem.title\" [parent]=\"\"\r\n                    *ngFor=\"let menuItem of menuItems\"\r\n                    [ngClass]=\"{'has-sub': menuItem.class === 'has-sub' ? true: false, 'open': activeTitles.includes(menuItem.title) && !nav_collapsed_open ? true : false, 'nav-collapsed-open': nav_collapsed_open && activeTitles.includes(menuItem.title)}\"\r\n                    [routerLinkActive]=\"menuItem.submenu.length != 0 ? '' : 'active'\" [routerLinkActiveOptions]=\"{exact: true}\">\r\n                    <a appSidebarAnchorToggle [routerLink]=\"menuItem.class === '' ? [menuItem.path] : null\"\r\n                       *ngIf=\"!menuItem.isExternalLink; else externalLinkBlock\">\r\n                        <i [ngClass]=\"[menuItem.icon]\"></i>\r\n                        <span class=\"menu-title\">{{menuItem.title | translate }}</span>\r\n                        <span *ngIf=\"menuItem.badge != '' \" [ngClass]=\"[menuItem.badgeClass]\">{{menuItem.badge}}</span>\r\n                    </a>\r\n                    <ng-template #externalLinkBlock>\r\n                        <a [href]=\"[menuItem.path]\" target=\"_blank\">\r\n                            <i [ngClass]=\"[menuItem.icon]\"></i>\r\n                            <span class=\"menu-title\">{{menuItem.title | translate }}</span>\r\n                            <span *ngIf=\"menuItem.badge != '' \" [ngClass]=\"[menuItem.badgeClass]\">{{menuItem.badge}}</span>\r\n                        </a>\r\n                    </ng-template>\r\n                    <!-- Second level menu -->\r\n                    <ul class=\"menu-content\" *ngIf=\"menuItem.submenu.length > 0\"\r\n                        [@slideInOut]=\"activeTitles.includes(menuItem.title) ? true : false\">\r\n                        <li appSidebarlink level=\"{{depth + 2}}\" (toggleEmit)=\"handleToggle($event)\" [routePath]=\"menuSubItem.path\"\r\n                            [classes]=\"menuSubItem.class\" [title]=\"menuSubItem.title\" [parent]=\"menuItem.title\"\r\n                            *ngFor=\"let menuSubItem of menuItem.submenu\" [routerLinkActive]=\"menuSubItem.submenu.length > 0 ? '' : 'active'\"\r\n                            [ngClass]=\"{'has-sub': menuSubItem.class === 'has-sub' ? true: false, 'open': activeTitles.includes(menuSubItem.title) && !nav_collapsed_open ? true : false, 'nav-collapsed-open': nav_collapsed_open && activeTitles.includes(menuSubItem.title)}\">\r\n                            <a appSidebarAnchorToggle [routerLink]=\"menuSubItem.submenu.length > 0 ? null : [menuSubItem.path]\"\r\n                               *ngIf=\"!menuSubItem.isExternalLink; else externalSubLinkBlock\">\r\n                                <i [ngClass]=\"[menuSubItem.icon]\"></i>\r\n                                <span class=\"menu-title\">{{menuSubItem.title | translate }}</span>\r\n                                <span *ngIf=\"menuSubItem.badge != '' \" [ngClass]=\"[menuSubItem.badgeClass]\">{{menuSubItem.badge}}</span>\r\n                            </a>\r\n                            <ng-template #externalSubLinkBlock>\r\n                                <a [href]=\"[menuSubItem.path]\">\r\n                                    <i [ngClass]=\"[menuSubItem.icon]\"></i>\r\n                                    <span class=\"menu-title\">{{menuSubItem.title | translate }}</span>\r\n                                    <span *ngIf=\"menuSubItem.badge != '' \" [ngClass]=\"[menuSubItem.badgeClass]\">{{menuSubItem.badge}}</span>\r\n                                </a>\r\n                            </ng-template>\r\n                            <!-- Third level menu -->\r\n                            <ul class=\"menu-content\" *ngIf=\"menuSubItem.submenu.length > 0\"\r\n                                [@slideInOut]=\"activeTitles.includes(menuSubItem.title) ? true : false\">\r\n                                <li appSidebarlink level=\"{{depth + 3}}\" [routePath]=\"menuSubsubItem.path\" [classes]=\"menuSubsubItem.class\"\r\n                                    [title]=\"menuSubsubItem.title\" [parent]=\"menuSubItem.title\"\r\n                                    *ngFor=\"let menuSubsubItem of menuSubItem.submenu\" routerLinkActive=\"active\"\r\n                                    [routerLinkActiveOptions]=\"{exact: true}\" [ngClass]=\"[menuSubsubItem.class]\">\r\n                                    <a appSidebarAnchorToggle [routerLink]=\"[menuSubsubItem.path]\"\r\n                                       *ngIf=\"!menuSubsubItem.isExternalLink; else externalSubSubLinkBlock\">\r\n                                        <i [ngClass]=\"[menuSubsubItem.icon]\"></i>\r\n                                        <span class=\"menu-title\">{{menuSubsubItem.title | translate }}</span>\r\n                                        <span *ngIf=\"menuSubsubItem.badge != '' \"\r\n                                              [ngClass]=\"[menuSubsubItem.badgeClass]\">{{menuSubsubItem.badge}}</span>\r\n                                    </a>\r\n                                    <ng-template #externalSubSubLinkBlock>\r\n                                        <a [href]=\"[menuSubsubItem.path]\">\r\n                                            <i [ngClass]=\"[menuSubsubItem.icon]\"></i>\r\n                                            <span class=\"menu-title\">{{menuSubsubItem.title | translate }}</span>\r\n                                            <span *ngIf=\"menuSubsubItem.badge != '' \"\r\n                                                  [ngClass]=\"[menuSubsubItem.badgeClass]\">{{menuSubsubItem.badge}}</span>\r\n                                        </a>\r\n                                    </ng-template>\r\n                                </li>\r\n                            </ul>\r\n                        </li>\r\n                    </ul>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n    </div>\r\n    <!-- Sidebar Content Ends -->\r\n    <div class=\"sidebar-footer\">\r\n        <div class=\"logo-footer\">\r\n            <ng-content select=\"[partnerLogo]\"></ng-content>\r\n        </div>\r\n        <div class=\"version-footer\" *ngIf=\"version\">\r\n            <p>{{('APPLICATION.MENU.version' | translate) + ': ' + version}}</p>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n",
                    animations: customAnimations,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".sidebar{box-shadow:-2px 0 5px 0 #42445a}.sidebar-content{background:#fff}"]
                }] }
    ];
    /** @nocollapse */
    SidebarComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: Router },
        { type: TranslateService },
        { type: ConfigService },
        { type: LayoutService }
    ]; };
    SidebarComponent.propDecorators = {
        toggleIcon: [{ type: ViewChild, args: ['toggleIcon', { static: false },] }],
        menuItems: [{ type: Input }],
        version: [{ type: Input }],
        logoUrl: [{ type: Input }]
    };
    return SidebarComponent;
}());
if (false) {
    /** @type {?} */
    SidebarComponent.prototype.toggleIcon;
    /** @type {?} */
    SidebarComponent.prototype.menuItems;
    /** @type {?} */
    SidebarComponent.prototype.version;
    /** @type {?} */
    SidebarComponent.prototype.depth;
    /** @type {?} */
    SidebarComponent.prototype.activeTitle;
    /** @type {?} */
    SidebarComponent.prototype.activeTitles;
    /** @type {?} */
    SidebarComponent.prototype.expanded;
    /** @type {?} */
    SidebarComponent.prototype.nav_collapsed_open;
    /** @type {?} */
    SidebarComponent.prototype.logoUrl;
    /** @type {?} */
    SidebarComponent.prototype.config;
    /** @type {?} */
    SidebarComponent.prototype.layoutSub;
    /**
     * @type {?}
     * @private
     */
    SidebarComponent.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    SidebarComponent.prototype.router;
    /** @type {?} */
    SidebarComponent.prototype.translate;
    /**
     * @type {?}
     * @private
     */
    SidebarComponent.prototype.configService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function RouteInfo() { }
if (false) {
    /** @type {?} */
    RouteInfo.prototype.path;
    /** @type {?} */
    RouteInfo.prototype.title;
    /** @type {?} */
    RouteInfo.prototype.icon;
    /** @type {?} */
    RouteInfo.prototype.class;
    /** @type {?} */
    RouteInfo.prototype.badge;
    /** @type {?} */
    RouteInfo.prototype.badgeClass;
    /** @type {?} */
    RouteInfo.prototype.isExternalLink;
    /** @type {?} */
    RouteInfo.prototype.submenu;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SidebarListDirective = /** @class */ (function () {
    function SidebarListDirective() {
        this.navlinks = [];
        this.activeLinks = [];
    }
    /**
     * @param {?} list
     * @return {?}
     */
    SidebarListDirective.prototype.setList = /**
     * @param {?} list
     * @return {?}
     */
    function (list) {
        this.navlinks = list;
    };
    /**
     * @param {?} link
     * @return {?}
     */
    SidebarListDirective.prototype.collapse = /**
     * @param {?} link
     * @return {?}
     */
    function (link) {
        link.open = false;
        this.setIsHidden(link);
        if (link.level.toString().trim() === '2') {
            this.activeLinks.push(this.navlinks
                .filter((/**
             * @param {?} _
             * @return {?}
             */
            function (_) { return _.level.toString().trim() === '1' && _.open === true; }))[0].title);
        }
        link.toggleEmit.emit(this.activeLinks);
    };
    /**
     * @param {?} link
     * @return {?}
     */
    SidebarListDirective.prototype.expand = /**
     * @param {?} link
     * @return {?}
     */
    function (link) {
        link.open = true;
        this.activeLinks.push(link.title);
        this.collapseOtherLinks(link);
        this.setIsShown(link);
        link.toggleEmit.emit(this.activeLinks);
    };
    /**
     * @param {?} openLink
     * @return {?}
     */
    SidebarListDirective.prototype.toggleActiveList = /**
     * @param {?} openLink
     * @return {?}
     */
    function (openLink) {
        this.navlinks
            .filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _.level.toString().trim() === '3'; }))
            .forEach((/**
         * @param {?} link
         * @return {?}
         */
        function (link) {
            if (link !== openLink) {
                link.active = false;
            }
        }));
    };
    /**
     * @param {?} openLink
     * @return {?}
     */
    SidebarListDirective.prototype.collapseOtherLinks = /**
     * @param {?} openLink
     * @return {?}
     */
    function (openLink) {
        var _this = this;
        if (openLink.level.toString().trim() === '1') {
            this.navlinks
                .filter((/**
             * @param {?} _
             * @return {?}
             */
            function (_) {
                return (_.level.toString().trim() === openLink.level.toString().trim() ||
                    _.level.toString().trim() === '2') &&
                    _.open === true;
            }))
                .forEach((/**
             * @param {?} link
             * @return {?}
             */
            function (link) {
                if (link !== openLink) {
                    link.open = false;
                    _this.setIsHidden(link);
                }
            }));
        }
        else if (openLink.level.toString().trim() === '2') {
            this.activeLinks.push(this.navlinks
                .filter((/**
             * @param {?} _
             * @return {?}
             */
            function (_) { return _.level.toString().trim() === '1' && _.open === true; }))[0].title);
            this.navlinks
                .filter((/**
             * @param {?} _
             * @return {?}
             */
            function (_) {
                return _.level.toString().trim() === openLink.level.toString().trim() &&
                    _.parent === openLink.parent &&
                    _.open === true;
            }))
                // tslint:disable-next-line: no-identical-functions
                .forEach((/**
             * @param {?} link
             * @return {?}
             */
            function (link) {
                if (link !== openLink) {
                    link.open = false;
                    _this.setIsHidden(link);
                }
            }));
        }
    };
    /**
     * @param {?} parentLink
     * @return {?}
     */
    SidebarListDirective.prototype.setIsShown = /**
     * @param {?} parentLink
     * @return {?}
     */
    function (parentLink) {
        /** @type {?} */
        var childLevel = Number(parentLink.level) + 1;
        this.navlinks
            .filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            return _.level.toString().trim() === childLevel.toString().trim() &&
                _.parent === parentLink.title;
        }))
            .forEach((/**
         * @param {?} link
         * @return {?}
         */
        function (link) {
            link.isShown = true;
            link.isHidden = false;
        }));
    };
    /**
     * @param {?} parentLink
     * @return {?}
     */
    SidebarListDirective.prototype.setIsHidden = /**
     * @param {?} parentLink
     * @return {?}
     */
    function (parentLink) {
        /** @type {?} */
        var childLevel = Number(parentLink.level) + 1;
        this.navlinks
            .filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            return _.level.toString().trim() === childLevel.toString().trim() &&
                _.parent === parentLink.title;
        }))
            .forEach((/**
         * @param {?} link
         * @return {?}
         */
        function (link) {
            link.isShown = false;
            link.isHidden = true;
        }));
    };
    SidebarListDirective.decorators = [
        { type: Directive, args: [{ selector: '[appSidebarList]' },] }
    ];
    return SidebarListDirective;
}());
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SidebarListDirective.prototype.navlinks;
    /** @type {?} */
    SidebarListDirective.prototype.activeLinks;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SidebarLinkDirective = /** @class */ (function () {
    function SidebarLinkDirective(sidebarList, sidebar, el) {
        this.el = el;
        this.toggleEmit = new EventEmitter();
        this.sidebarList = sidebarList;
        this.sidebar = sidebar;
    }
    Object.defineProperty(SidebarLinkDirective.prototype, "open", {
        get: /**
         * @return {?}
         */
        function () {
            return this._open;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._open = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidebarLinkDirective.prototype, "navCollapsedOpen", {
        get: /**
         * @return {?}
         */
        function () {
            return this._navCollapsedOpen;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._navCollapsedOpen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidebarLinkDirective.prototype, "active", {
        get: /**
         * @return {?}
         */
        function () {
            return this._active;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._active = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidebarLinkDirective.prototype, "isShown", {
        get: /**
         * @return {?}
         */
        function () {
            return this._isShown;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._isShown = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidebarLinkDirective.prototype, "isHidden", {
        get: /**
         * @return {?}
         */
        function () {
            return this._isHidden;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._isHidden = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SidebarLinkDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.sidebar.addLink(this);
    };
    /**
     * @return {?}
     */
    SidebarLinkDirective.prototype.toggle = /**
     * @return {?}
     */
    function () {
        this.sidebarList.activeLinks = [];
        this.sidebarList.setList(this.sidebar.getLinks());
        /** @type {?} */
        var classList = this.el.nativeElement.classList;
        if (this.level.toString().trim() === '1' && !classList.contains('has-sub')) {
            this.sidebarList.collapseOtherLinks(this);
        }
        if (this.level.toString().trim() === '2' || this.level.toString().trim() === '3') {
            this.sidebarList.toggleActiveList(this);
        }
        if (classList.contains('has-sub')) {
            if (classList.contains('open')) {
                this.sidebarList.collapse(this);
            }
            else {
                this.sidebarList.expand(this);
            }
        }
        else {
            this.active = true;
            this.sidebar.hideSidebar();
        }
    };
    SidebarLinkDirective.decorators = [
        { type: Directive, args: [{ selector: '[appSidebarlink]' },] }
    ];
    /** @nocollapse */
    SidebarLinkDirective.ctorParameters = function () { return [
        { type: SidebarListDirective, decorators: [{ type: Inject, args: [SidebarListDirective,] }] },
        { type: SidebarDirective, decorators: [{ type: Inject, args: [SidebarDirective,] }] },
        { type: ElementRef }
    ]; };
    SidebarLinkDirective.propDecorators = {
        level: [{ type: Input }],
        classes: [{ type: Input }],
        parent: [{ type: Input }],
        title: [{ type: Input }],
        routePath: [{ type: Input }],
        toggleEmit: [{ type: Output }],
        open: [{ type: HostBinding, args: ['class.open',] }, { type: Input }],
        navCollapsedOpen: [{ type: HostBinding, args: ['class.nav-collapsed-open',] }, { type: Input }],
        active: [{ type: HostBinding, args: ['class.active',] }, { type: Input }],
        isShown: [{ type: HostBinding, args: ['class.is-shown',] }, { type: Input }],
        isHidden: [{ type: HostBinding, args: ['class.is-hidden',] }, { type: Input }]
    };
    return SidebarLinkDirective;
}());
if (false) {
    /** @type {?} */
    SidebarLinkDirective.prototype.level;
    /** @type {?} */
    SidebarLinkDirective.prototype.classes;
    /** @type {?} */
    SidebarLinkDirective.prototype.parent;
    /** @type {?} */
    SidebarLinkDirective.prototype.title;
    /** @type {?} */
    SidebarLinkDirective.prototype.routePath;
    /** @type {?} */
    SidebarLinkDirective.prototype.toggleEmit;
    /**
     * @type {?}
     * @protected
     */
    SidebarLinkDirective.prototype._open;
    /**
     * @type {?}
     * @protected
     */
    SidebarLinkDirective.prototype._navCollapsedOpen;
    /**
     * @type {?}
     * @protected
     */
    SidebarLinkDirective.prototype._active;
    /**
     * @type {?}
     * @protected
     */
    SidebarLinkDirective.prototype._isShown;
    /**
     * @type {?}
     * @protected
     */
    SidebarLinkDirective.prototype._isHidden;
    /**
     * @type {?}
     * @protected
     */
    SidebarLinkDirective.prototype.sidebarList;
    /**
     * @type {?}
     * @protected
     */
    SidebarLinkDirective.prototype.sidebar;
    /**
     * @type {?}
     * @private
     */
    SidebarLinkDirective.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SidebarAnchorToggleDirective = /** @class */ (function () {
    function SidebarAnchorToggleDirective(navlink) {
        this.navlink = navlink;
    }
    /**
     * @return {?}
     */
    SidebarAnchorToggleDirective.prototype.onClick = /**
     * @return {?}
     */
    function () {
        this.navlink.toggle();
    };
    SidebarAnchorToggleDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[appSidebarAnchorToggle]'
                },] }
    ];
    /** @nocollapse */
    SidebarAnchorToggleDirective.ctorParameters = function () { return [
        { type: SidebarLinkDirective, decorators: [{ type: Inject, args: [SidebarLinkDirective,] }] }
    ]; };
    SidebarAnchorToggleDirective.propDecorators = {
        onClick: [{ type: HostListener, args: ['click',] }]
    };
    return SidebarAnchorToggleDirective;
}());
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SidebarAnchorToggleDirective.prototype.navlink;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SidebarToggleDirective = /** @class */ (function () {
    function SidebarToggleDirective(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        // tslint:disable-next-line: variable-name
        this._dataToggle = 'expanded';
        // tslint:disable-next-line: variable-name
        this._toggleRight = true;
        // tslint:disable-next-line: variable-name
        this._toggleLeft = false;
    }
    Object.defineProperty(SidebarToggleDirective.prototype, "dataToggle", {
        get: /**
         * @return {?}
         */
        function () {
            return this._dataToggle;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._dataToggle = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidebarToggleDirective.prototype, "toggleRight", {
        get: /**
         * @return {?}
         */
        function () {
            return this._toggleRight;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._toggleRight = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidebarToggleDirective.prototype, "toggleLeft", {
        get: /**
         * @return {?}
         */
        function () {
            return this._toggleLeft;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._toggleLeft = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SidebarToggleDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.$wrapper = document.getElementsByClassName('wrapper')[0];
        this.compact_menu_checkbox = this.$wrapper.querySelector('.cz-compact-menu');
    };
    /**
     * @param {?} e
     * @return {?}
     */
    SidebarToggleDirective.prototype.onClick = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        if (this.dataToggle === 'expanded') {
            this.dataToggle = 'collapsed';
            this.renderer.addClass(this.$wrapper, 'nav-collapsed');
            if (this.compact_menu_checkbox) {
                this.compact_menu_checkbox.checked = true;
            }
        }
        else {
            this.dataToggle = 'expanded';
            this.renderer.removeClass(this.$wrapper, 'nav-collapsed');
            this.renderer.removeClass(this.$wrapper, 'menu-collapsed');
            if (this.compact_menu_checkbox) {
                this.compact_menu_checkbox.checked = false;
            }
        }
        this.toggleLeft = !this.toggleLeft;
        this.toggleRight = !this.toggleRight;
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.fireRefreshEventOnWindow();
        }), 300);
    };
    /**
     * @return {?}
     */
    SidebarToggleDirective.prototype.fireRefreshEventOnWindow = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var evt = document.createEvent('HTMLEvents');
        evt.initEvent('resize', true, false);
        window.dispatchEvent(evt);
    };
    SidebarToggleDirective.decorators = [
        { type: Directive, args: [{ selector: '[appSidebarToggle]' },] }
    ];
    /** @nocollapse */
    SidebarToggleDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    SidebarToggleDirective.propDecorators = {
        dataToggle: [{ type: HostBinding, args: ['attr.data-toggle',] }, { type: Input }],
        toggleRight: [{ type: HostBinding, args: ['class.ft-toggle-right',] }, { type: Input }],
        toggleLeft: [{ type: HostBinding, args: ['class.ft-toggle-left',] }, { type: Input }],
        onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
    };
    return SidebarToggleDirective;
}());
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SidebarToggleDirective.prototype._dataToggle;
    /**
     * @type {?}
     * @protected
     */
    SidebarToggleDirective.prototype._toggleRight;
    /**
     * @type {?}
     * @protected
     */
    SidebarToggleDirective.prototype._toggleLeft;
    /**
     * @type {?}
     * @protected
     */
    SidebarToggleDirective.prototype.$wrapper;
    /**
     * @type {?}
     * @protected
     */
    SidebarToggleDirective.prototype.compact_menu_checkbox;
    /**
     * @type {?}
     * @private
     */
    SidebarToggleDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    SidebarToggleDirective.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    SharedModule.decorators = [
        { type: NgModule, args: [{
                    exports: [
                        CommonModule,
                        NavbarComponent,
                        SidebarComponent,
                        NotificationSidebarComponent,
                        ToggleFullscreenDirective,
                        SidebarDirective,
                        NgbModule,
                        TranslateModule,
                        PerfectScrollbarModule
                    ],
                    imports: [
                        RouterModule,
                        CommonModule,
                        NgbModule,
                        TranslateModule,
                        PerfectScrollbarModule
                    ],
                    declarations: [
                        NavbarComponent,
                        SidebarComponent,
                        NotificationSidebarComponent,
                        ToggleFullscreenDirective,
                        SidebarDirective,
                        SidebarLinkDirective,
                        SidebarListDirective,
                        SidebarAnchorToggleDirective,
                        SidebarToggleDirective
                    ]
                },] }
    ];
    return SharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ConfigService, LayoutService, NavbarComponent, NotificationSidebarComponent, SharedModule, SidebarComponent, SidebarDirective, ToggleFullscreenDirective, FullscreenService as ɵa, customAnimations as ɵb, SidebarLinkDirective as ɵc, SidebarListDirective as ɵd, SidebarAnchorToggleDirective as ɵe, SidebarToggleDirective as ɵf };
//# sourceMappingURL=apex-shared.js.map
